import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { Observable } from 'rxjs';
import { ArchivosFormDTO } from '../../../../../dto/expediente/archivos-form.dto';

@Injectable({
  providedIn: 'root',
})
export class ProteccionConsumidorService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  crear(
    data: TramiteSicProteccionConsumidorDto,
    enviarCorreoDemandado: boolean,
    archivos: ArchivosFormDTO | null | undefined = undefined
  ): Observable<TramiteSicProteccionConsumidorDto> {
    const formData = new FormData();

    // Agregar los archivos
    if(archivos){
      archivos.Archivos.forEach((archivo) => {
        formData.append('archivos', archivo);
      });
    }

    // Agregar datos del DTO (como campos separados)
    formData.append('tramite', JSON.stringify(data));
    formData.append(
      'enviarCorreoDemandado',
      String(enviarCorreoDemandado ?? false)
    );

    return this.http.post(
      `${this.apiUrl}/sic/tramite/crearTramiteProteccionConsumidor`,
      formData
    );
  }

  cargarTramitePendiente(
    idTramite: number
  ): Observable<TramiteSicProteccionConsumidorDto> {
    return this.http.get<TramiteSicProteccionConsumidorDto>(
      `${this.apiUrl}/tramite/tramite-pendiente/cargar/${idTramite}`
    );
  }

  // Servicio para eliminar las pretensiones asociadas al trámite
  eliminarPretensiones(idTramite: number) {
    return this.http.delete<any>(
      `${this.apiUrl}/sic/tramite/detalle-sic/${idTramite}`
    );
  }
}
